import React from 'react';
import Checkbox from '@material-ui/core/Checkbox'

const WrapCheckbox = ({ input,label,meta: {  error } }) => (
  <div>
    <Checkbox
      checked={input.value ? true : false}
      onChange={input.onChange}
    />
    &nbsp;
    {label}
    &nbsp;{error? ( <span style={{color: 'red'}} >**{error}</span>  ):null}
  </div>
)

export default WrapCheckbox;


// WEBPACK FOOTER //
// ./src/views/ImageCategorisation/WrapCheckbox.js